<template>
  <div class="add-form">
    <Form ref="addForm" :model="form" :rules="diyData.rules" :label-width="100">
      <div class="tag-title">通知栏</div>
      <Row>
        <Col span="8">
          <FormItem label="是否显示">
            <RadioGroup v-model="form.status">
              <Radio label="1">显示</Radio>
              <Radio label="2">隐藏</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem prop="status">
            <div class="banner-item">
              <div class="right">
                <span class="span-title">请选择类型：</span>
                <RadioGroup v-model="form.target_type" @on-change="typeChange">
                  <Radio label="1">文章</Radio>
                  <Radio label="2">赛事</Radio>
                  <Radio label="3">活动</Radio>
                </RadioGroup>
                <div style="margin-top: 10px" v-if="form.target_type != 0">
                  <span class="span-title">请选择：</span>
                  <Select filterable v-if="form.target_type == 1" style="width: 200px" @on-change="selectChange" v-model="form.target_id">
                    <Option
                      v-for="(item, index) in apiData.articleList"
                      :key="index"
                      :label="item.title"
                      :value="item.id"
                    ></Option>
                  </Select>
                  <Select filterable v-if="form.target_type == 2" style="width: 200px" @on-change="selectChange" v-model="form.target_id">
                    <Option
                      v-for="(item, index) in apiData.competitionsList"
                      :key="index"
                      :label="item.title"
                      :value="item.id"
                    ></Option>
                  </Select>
                  <Select filterable v-if="form.target_type == 3" style="width: 200px" @on-change="selectChange" v-model="form.target_id">
                    <Option
                      v-for="(item, index) in apiData.activityList"
                      :key="index"
                      :label="item.title"
                      :value="item.id"
                    ></Option>
                  </Select>
                </div>
              </div>
            </div>
          </FormItem>
        </Col>
      </Row>
      <FormItem>
        <Button type="primary" style="width: 90px; margin-right: 20px" @click="submit">保存</Button>
      </FormItem>
    </Form>
  </div>
</template>

<script>
  import * as apiArticle from '@/api/article'
  import * as apiCompetition from '@/api/activity/competitions'
  import * as apiActivity from '@/api/activity/activity'
  import * as apiSetting from '@/api/setting'
  export default {
    name: 'add-form',
    data() {
      return {
        query: {},
        search: {},
        diyDom: {},
        // 表单数据
        form: {
          status:'1',
          target_type: '1',
          target_id: '',
          title:'',
        },
        diyData: {
          rules: {},
        },
        apiData: {
          articleList: [], // 文章
          competitionsList: [], // 赛事
          activityList: [], // 活动
        },
      }
    },
    computed: {},
    methods: {
      // 获取文章不分页
      getArticle() {
        apiArticle.apiArticleList().then(res => {
          this.apiData.articleList = res.data
        })
      },
      // 获取赛事列表
      getCompetitionsList() {
        apiCompetition.apiCompetitionsList().then(res => {
          this.apiData.competitionsList = res.data
        })
      },
      // 获取活动列表
      getActivityList() {
        apiActivity.apiActivitiesList().then(res => {
          this.apiData.activityList = res.data
        })
      },
      // 获取详情
      getDetail() {
        this.$store.commit('setSpinShow', true)
        apiSetting
          .apiGetSystem('roll_notice ')
          .then(res => {
            this.form = res.data
          })
          .finally(() => this.$store.commit('setSpinShow', false))
      },
      typeChange() {
        this.form.target_id = ''
      },
      selectChange(e) {
        let list = []
        if(this.form.target_type == 1) {
          list = this.apiData.articleList
        } else if(this.form.target_type == 2) {
          list = this.apiData.competitionsList
        } else {
          list = this.apiData.activityList
        }
        if(e) {
          this.form.title = list.find(item => item.id == e).title || ''
        }
      },
      submit() {
        apiSetting
          .apiSetSystem('roll_notice ', {
            roll_notice: this.form,
          })
          .then(res => {
            this.$Message.success('保存成功')
            this.$bus.$emit('on-change')
            this.getDetail()
          })
      },
    },
    mounted() {
      this.getArticle()
      this.getCompetitionsList()
      this.getActivityList()
      this.getDetail()
    },
  }
</script>

<style scoped lang="less">
  .add-form {
    border: 1px solid #ededed;
    margin: 0 20px;
    padding: 26px 20px;

    .title {
      border-left: 5px solid #2d8cf0;
      padding: 0 0 0 10px;
      margin: 0 20px 20px;
      font-weight: bold;
    }
    .tips-item {
      display: flex;
      margin-bottom: 10px;
    }
    .delete {
      margin-left: 10px;
      cursor: pointer;
      display: flex;
      align-items: center;
      color: red;
    }
    .add {
      margin-left: 10px;
      cursor: pointer;
      display: flex;
      align-items: center;
      color: #2d8cf0;
    }
  }
</style>
